// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__3GELc","title":"AfterImages90_title__3qI-_","images":"AfterImages90_images__3lXio"};